// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acc_line {
    font-size: 12px;
    margin-top: 5%;
   
  }

  .soarting_margin{
    margin-right: 31%;
  }
  
  .acc_select{
    font-size: 13px;
    width: 100%;
      display: inline-block;
      float: left;
      margin-top: 3%;
      position: relative;
  }

  .acc_btn{
    width: 12%
  }
  
  .acc_btn:focus{
    background-color: #ffffff !important;
    box-shadow: inset 0 -1px 0 rgb(255 255 255 / 13%) !important;
  
  }
  
  .acc_btn:not(.collapsed){
    background-color: #ffffff !important;
    box-shadow: inset 0 -1px 0 rgb(255 255 255 / 13%) !important;
  
  }
  /* .acc_btn_bus:focus{
    background-color: #e0e0e0 !important;
    box-shadow: inset 0 -1px 0 rgb(255 255 255 / 13%) !important;
  
  }
  
  .acc_btn_bus:not(.collapsed){
    background-color: #e0e0e0 !important;
    box-shadow: inset 0 -1px 0 rgb(255 255 255 / 13%) !important;
  
  } */`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/Driveanalysis/TopFiveSectionTemplate.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc;;EAEhB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;MACT,qBAAqB;MACrB,WAAW;MACX,cAAc;MACd,kBAAkB;EACtB;;EAEA;IACE;EACF;;EAEA;IACE,oCAAoC;IACpC,4DAA4D;;EAE9D;;EAEA;IACE,oCAAoC;IACpC,4DAA4D;;EAE9D;EACA;;;;;;;;;;KAUG","sourcesContent":[".acc_line {\r\n    font-size: 12px;\r\n    margin-top: 5%;\r\n   \r\n  }\r\n\r\n  .soarting_margin{\r\n    margin-right: 31%;\r\n  }\r\n  \r\n  .acc_select{\r\n    font-size: 13px;\r\n    width: 100%;\r\n      display: inline-block;\r\n      float: left;\r\n      margin-top: 3%;\r\n      position: relative;\r\n  }\r\n\r\n  .acc_btn{\r\n    width: 12%\r\n  }\r\n  \r\n  .acc_btn:focus{\r\n    background-color: #ffffff !important;\r\n    box-shadow: inset 0 -1px 0 rgb(255 255 255 / 13%) !important;\r\n  \r\n  }\r\n  \r\n  .acc_btn:not(.collapsed){\r\n    background-color: #ffffff !important;\r\n    box-shadow: inset 0 -1px 0 rgb(255 255 255 / 13%) !important;\r\n  \r\n  }\r\n  /* .acc_btn_bus:focus{\r\n    background-color: #e0e0e0 !important;\r\n    box-shadow: inset 0 -1px 0 rgb(255 255 255 / 13%) !important;\r\n  \r\n  }\r\n  \r\n  .acc_btn_bus:not(.collapsed){\r\n    background-color: #e0e0e0 !important;\r\n    box-shadow: inset 0 -1px 0 rgb(255 255 255 / 13%) !important;\r\n  \r\n  } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
